export default __webpack_public_path__ + "static/media/subaruSouthTampa.f99643fd.png";